import { Button } from 'antd';
import React, { useState, forwardRef, useRef, useImperativeHandle } from 'react';
import { PoweroffOutlined,SaveOutlined } from '@ant-design/icons';
const SubmitBtn = ({label,loading}) => {    
    return (
        <Button type="primary" danger htmlType="submit" loading={loading} icon={<SaveOutlined />}>
            {label}
        </Button>
    )
}
// const SubmitBtn = forwardRef(({label,loading}, ref) => {
//     //const [loading, setLoading] = useState(false);   
//     useImperativeHandle(ref, () => ({          
//         setLoader(loading) {
//             //setLoading(loading);
//         }
//     }));
//     return (
//         <Button type="primary" danger htmlType="submit" loading={loading} icon={<PoweroffOutlined />}>
//             {label}
//         </Button>
//     )
// });
export default SubmitBtn